module.exports = __webpack_public_path__ + "static/media/flag.97a4eb7e.svg";